import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/ship/Localization';

Vue.use(VueI18n);

export default new VueI18n({
    locale: 'ru',
    fallbackLocale: 'en',
    messages,
    pluralizationRules: {
        ru(choice, choicesLength) {
            const n = Math.abs(choice);
            const n10 = n % 10;
            const n100 = n % 100;

            if (choicesLength === 1) {
                return 0;
            }

            if (n10 === 1 && n100 !== 11) {
                return 0;
            }

            if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) {
                return 1;
            }

            return 2;
        },
    },
});
